module.exports = __webpack_public_path__ + "img/eclosia.355984c0.png";